import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=134132c3&scoped=true&"
import script from "./Spaces.vue?vue&type=script&lang=js&"
export * from "./Spaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134132c3",
  null
  
)

export default component.exports